import { connect } from "react-redux";
import React, { Component } from "react";
import Modal from "../../utils/customModal";
import { ReactTitle } from "react-meta-tags";
import DashboardLine from "../dashboard/line";
import { withRouter } from "react-router-dom";
import Tabs from "../../public/tableProvider/tabs";
import FilterComponent from "../../utils/searchBar";
import { getRoles, getSessionCountry } from "../../../Redux/reducer/session";
import i18next from "i18next";
import { withTranslation } from "react-i18next";
import { handleWorkingHours } from "../../utils/utilities";
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import {
  getUserHolidayByCountry,
  workingHoursHandler,
} from "../../../Redux/actions/userActions";
import {
  getHolidayStatus,
  getHolidaysByCountry,
  getisWithinWorkingHours,
} from "../../../Redux/reducer/users";

//importe de imagenes
import MainTemplate from "../mainTemplate/";
import ApprovedList from "../bills/lists/approved";
import { loadingHtml, urlParam } from "../../utils/functions";
import ValidatedList from "../bills/lists/validated";
import ByStatus from "./lists/byStatus";

const filters = [
  { name: "Nombre", property: "company.institution.name", operator: "eq" },
  {
    name: "Identificación",
    property: "company.institution.businessId",
    operator: "eq",
  },
];

const defaultHoldAmount = {
  USD: { hold: 0, payAmount: 0 },
  CRC: { hold: 0, payAmount: 0 },
};

//

export class Bill extends Component {
  constructor(props) {
    super(props);

    this.state = {
      holdMount: defaultHoldAmount,
      modal: true,
      searchFilters: false,
      stateFilters: [],
      showAlert: true,
    };
  }

  handleWorkingHours = (statusOk) => {
    const { countryCode, holidaysByCountryCode } = this.props;

    if (holidaysByCountryCode?.isHoliDay || !statusOk) {
      this.props.workingHoursHandler({
        isWithinWorkingHours: false,
        holidayStatusOk: statusOk,
      });

      return;
    }

    const isWithinWorkingHours = handleWorkingHours(countryCode);

    this.props.workingHoursHandler({
      isWithinWorkingHours,
      holidayStatusOk: statusOk,
    });
  };

  handleHolidays = async () => {
    const { countryCode } = this.props;
    let statusOk = false;
    try {
      await this.props.getUserHolidayByCountry(countryCode);
      statusOk = true;
    } finally {
      this.handleWorkingHours(statusOk);
    }
  };

  componentDidMount() {
    this.handleHolidays();
  }

  setModal = (modal) => {
    this.setState({ modal });
  };

  search = (searchProperty, serachTerm = "") => {
    var actionFilters = [];

    if (serachTerm !== "") {
      // Realizamos la busqueda por filtros
      var operator = "";
      filters.map((item) => {
        if (item.property == searchProperty) {
          operator = item.operator;
        }
      });
      actionFilters = [
        { property: searchProperty, operator: operator, value: serachTerm },
      ];

      this.setState({ searchFilters: true, stateFilters: actionFilters });
    } else {
      this.setState({ searchFilters: false, stateFilters: [] });
    }
  };

  updateHoldMount = (bills = {}) => {
    const holdMount = Object.keys(bills).reduce(
      (acc, item) => {
        const { billPayAmount, monto, currency } = bills[item];

        acc[currency] = {
          hold: acc[currency].hold + monto,
          payAmount: acc[currency].payAmount + billPayAmount,
        };

        return acc;
      },
      { ...defaultHoldAmount }
    );

    this.setState({ holdMount });
  };

  updateAlert = () => {
    this.setState({ showAlert: !this.state.showAlert });
  };

  TableBill = () => {
    const { stateFilters } = this.state;
    const { location } = this.props;

    const param = urlParam(location.search, "status");
    var filter = null !== param ? param : "";

    var activeTab = "";
    if (filter !== "") {
      activeTab = "Facturas por estado";
    }

    return (
      <React.Fragment>
        {this.state.showAlert &&
          !this.props?.isWithinWorkingHours &&
          this.props?.holidayStatus && (
            <div className="working-hours-alert-banner">
              <AlertBanner type="error">
                {this.props.t(
                  `providers.alerts.${
                    this.props.countryCode === "PA"
                      ? "not_working_hours_PA"
                      : "not_working_hours_CR"
                  }`
                )}
              </AlertBanner>
            </div>
          )}
        {this.state.showAlert && !this.props?.holidayStatus &&
          this.state.tabSelected !== "by-status" && (
            <AlertBanner type="error" className="alertMsg">
              {this.props.t(
              `providers.alerts.${
                this.props.countryCode === "CR"
                  ? "holiday_request_failed_CR"
                  : "holiday_request_failed_PA"
              }`
            )}
            </AlertBanner>
          )}
        <FilterComponent filter={filters} searchFnc={this.search} />
        <Tabs activeTab={activeTab}>
          <div label={i18next.t("general.tabs.bills_validated")}>
            <ApprovedList
              filters={stateFilters}
              setModal={this.setModal}
              updateCreditLine={this.updateHoldMount}
            />
          </div>
          <div label={i18next.t("general.tabs.bills_status")}>
            <ByStatus
              filters={stateFilters}
              setModal={this.setModal}
              byStatus={filter}
              updateAlert={this.updateAlert}
            />
          </div>
          <div label={i18next.t("general.tabs.bills_available_discount")}>
            <ValidatedList
              filters={stateFilters}
              setModal={this.setModal}
              updateCreditLine={this.updateHoldMount}
            />
          </div>
        </Tabs>
      </React.Fragment>
    );
  };

  render() {
    return (
      <MainTemplate className="wrapper-bill">
        <ReactTitle title={`Gestión de facturas - Reverse Factoring`} />
        <DashboardLine holdMount={this.state.holdMount} />
        {this.TableBill()}

        <Modal show={this.state.modal}>{loadingHtml()}</Modal>
      </MainTemplate>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    countryCode: getSessionCountry(state),
    holidaysByCountryCode: getHolidaysByCountry(state),
    isWithinWorkingHours: getisWithinWorkingHours(state),
    holidayStatus: getHolidayStatus(state),
  };
};

export const mapDispatch = (dispatch) => ({
  getUserHolidayByCountry: (payload) =>
    dispatch(getUserHolidayByCountry(payload)),
  workingHoursHandler: (payload) => dispatch(workingHoursHandler(payload)),
});

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatch)(Bill))
);
